import { render } from "./Vendedor.vue?vue&type=template&id=3f289b08"
import script from "./Vendedor.vue?vue&type=script&lang=js"
export * from "./Vendedor.vue?vue&type=script&lang=js"

import "./Vendedor.vue?vue&type=style&index=0&id=3f289b08&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__